import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";

export class GetWorkloadReqData implements IFilterInstallations, IPaginationFilter {
    public startDate: Date = null;
    public endDate: Date = null;
    public currency: string = null;

    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = null;

    // PaginationFilter
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    constructor(other: GetWorkloadReqData) {

        if (other) {

            this.startDate = other.startDate;
            this.endDate = other.endDate;
            this.currency = other.currency;

            // FilterInstallations
            if (other.installationNames != null && other.installationNames.length > 0) {
                this.installationNames = [];
                other.installationNames.forEach(e => {
                    this.installationNames.push(e);
                });
            }

            if (other.folderIds != null && other.folderIds.length > 0) {
                this.folderIds = [];
                other.folderIds.forEach(e => {
                    this.folderIds.push(e);
                });
            }

            if (other.branchNames != null && other.branchNames.length > 0) {
                this.branchNames = [];
                other.branchNames.forEach(e => {
                    this.branchNames.push(e);
                });
            }

            // PaginationFilter
            this.queryLimit = other.queryLimit;
            this.offset = other.offset;

            if (other.orderBy != null && other.orderBy.length > 0) {
                this.orderBy = [];
                other.orderBy.forEach(e => {
                    this.orderBy.push(e);
                });
            }

            if (other.orderByDescending != null && other.orderByDescending.length > 0) {
                this.orderByDescending = [];
                other.orderByDescending.forEach(e => {
                    this.orderByDescending.push(e);
                });
            }
        }
    }

}